import { useMemo } from "react";

import ShareButton from "components/ShareButton";
import { emberAppBaseUrl } from "utils/envVariables";

export const CollectionShareButton = ({
  collection,
  style = "pill-button",
}: any) => {
  const name = collection?.name;
  const link = `${emberAppBaseUrl}/collections/${collection.slug}`;
  const title = `Check this out: ${name} ${link}`;

  const shareBtnOptions = useMemo(
    () => ({
      email: {
        link: `mailto:?subject=\u272a Smartkarma | ${name}&body=${title}`,
      },
      clipboard: {
        message: title,
      },
      privateMessage: {
        message: `Collection | ${name}: <a href="${link}">${link}</a>`,
      },
      whatsapp: {
        link: `https://web.whatsapp.com/send?text=${title}`,
      },
      twitter: {
        link: `https://twitter.com/share?url=${link}&text=${title}&via=smartkarma`,
      },
      linkedIn: {
        link: `https://www.linkedin.com/shareArticle?mini=true&url=${link}&source=Smartkarma`,
      },
    }),
    [link, name, title]
  );

  return (
    <ShareButton
      collection={collection}
      options={shareBtnOptions}
      columnView
      type={style}
      noTooltip
    >
      Share
    </ShareButton>
  );
};

export default CollectionShareButton;
